import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '@sdbn/common';

export class ActionTabletConfirmDialogData {
  titleKey: string;
  messageKey: string;
  messageParams?: any[];
  confirmBtnKey?: string = null;
  confirm: () => void;
  cancel?: () => void;
}

@Component({
    selector: 'app-action-tablet-confirm-dialog',
    templateUrl: 'action-tablet-confirm.dialog.component.html',
    styleUrls: ['action-tablet-confirm.dialog.component.scss'],
    standalone: false
})
export class ActionTabletConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ActionTabletConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ActionTabletConfirmDialogData,
    public translationService: TranslationService) {
    }

  confirm() {
    this.dialogRef.close(true);
    this.data.confirm();
  }

  cancel() {
    this.dialogRef.close();
    if (this.data.cancel) {
      this.data.cancel();
    }
  }

  public getMessageArgs() {
    const args: any[] = [];

    args.push(this.data.messageKey);
    args.push(this.translationService.language);

    if (this.data.messageParams != null) {
      for (const p of this.data.messageParams) {
        args.push(p);
      }
    }

    return args;
  }
}
